<template>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12">
                <b-card>
                    <div slot="header">
                        <i :class="[isEditing ? 'fa-edit' : 'fa-plus-square-o', 'fa']"></i><strong> Lichtintegratie vs. klassiek belichtingsschema</strong>
                        <small>
                            samenvatting
                        </small>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm">
                                <tbody>
                                <tr>
                                    <th>Afdeling: </th><td>{{model.afdeling.naam}}</td>

                                </tr>
                                <tr>
                                    <th>Gewas: </th><td>{{model.teelt.naam}} - {{model.ras}}</td>
                                    <th>Aanplantdatum - einddatum: </th>
                                    <td>{{datumDDMMYYYY(model.aanplantdatum)}} - {{datumDDMMYYYY(model.einddatum)}}</td>
                                </tr>
                                <tr>
                                    <th>Gewenste DLI: </th><td>{{model.ingesteldeDli}}</td>
                                    <th>Belichtingsseizoen start - einde: </th>
                                    <td>{{datumDDMMYYYY(model.startdatumBelichting)}} - {{datumDDMMYYYY(model.einddatumBelichting)}}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            &nbsp;<br />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-striped table-sm">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th></th>
                                    <th>Installatie (&#181;mol/m<sup>2</sup>s)</th>
                                    <th>Efficiëntie (&#181;mol/J)</th>
                                </tr>
                                </thead>
                                <tbody>
                                <template v-for="(belichting, indexi, i) in model.afdeling.belichting_n">
                                    <template v-for="(schakelniveau, indexj, i) in belichting.schakelniveau_n">
                                        <tr>
                                            <td>Systeem {{schakelniveau.nummer + 1}}</td>
                                            <td>{{belichting.soortbelichting.naam}} {{indexj + 1}}</td>
                                            <td>{{komma4(installatie[schakelniveau.nummer])}}</td>
                                            <td>{{belichting.efficientie}}</td>
                                        </tr>
                                    </template>
                                </template>

                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12">
                            &nbsp;<br />
                        </div>
                    </div>

                    <div v-show="!schemabestaat" class="row">
                        <div class="col-12">
                            <p class="red">Er bestaat nog geen klassiek belichtingsschema voor deze teelt. Gelieve dit eerst te creëren.</p>
                        </div>
                        <div class="col-12">
                            &nbsp;<br />
                        </div>
                    </div>

                    <div v-show="schemabestaat" class="row">
                        <div class="col-sm-6">
                            <div class="form-group">
                                <b-button-group id="periode" name="periode">
                                    <b-button @click="changeView('data')" variant="outline-secondary" :pressed="currentview == 'data'">Data</b-button>
                                    <b-button @click="changeView('energie')" variant="outline-secondary" :pressed="currentview == 'energie'">Energie</b-button>
                                    <b-button @click="changeView('grafiek')" variant="outline-secondary" :pressed="currentview == 'grafiek'">Grafieken</b-button>
                                </b-button-group>
                            </div>
                            &nbsp<br />
                        </div><!--/.col-->
                        <div v-show="currentview == 'grafiek'" class="col-sm-6">
                            <b-input-group>
                                <b-input-group left="Van">
                                    <datepicker @input="fillGraphs()" :required="true" v-model="begindatum" :bootstrapStyling="true" style="background-color : #ffffff;" :disabled-dates="disabled" :full-month-name="true" :language="nl" :monday-first="true" name="begindatum" id="begindatum" ref="begindatum" format="d MMMM yyyy" minimumView="day" maximumView="year" initialView="day"></datepicker>
                                </b-input-group>
                                &nbsp;&nbsp;
                                <b-input-group left="Tot">
                                    <datepicker @input="fillGraphs()" :required="true" v-model="einddatum" :bootstrapStyling="true" style="background-color : #ffffff;" :disabled-dates="disabled" :full-month-name="true" :language="nl" :monday-first="true" name="einddatum" id="einddatum" ref="einddatum" format="d MMMM yyyy" minimumView="day" maximumView="year" initialView="day"></datepicker>
                                </b-input-group>
                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                            </b-input-group>
                        </div><!--/.col-->
                    </div>

                    <div v-show="schemabestaat && currentview == 'data'" class="row animated fadeIn">
                        <div class="col-12">
                            <table class="table table-striped table-sm text-center table-fixed">
                                <thead>
                                <tr>
                                    <th class="rborder"></th>
                                    <th></th>
                                    <th class="rborder"></th>
                                    <th style="text-align: center;" :colspan="3" class="rborder">Klassieke belichting</th>
                                    <th style="text-align: center;" :colspan="3">Lichtintegratie</th>
                                </tr>
                                <tr>
                                    <th class="rborder">Datum</th>
                                    <th>DLI gewenst (mol/m<sup>2</sup>)</th>
                                    <th class="rborder">DLI zon (mol/m<sup>2</sup>)</th>
                                    <th>DLI belichting (mol/m<sup>2</sup>)</th>
                                    <th>DLI werkelijk<br />ontvangen (mol/m<sup>2</sup>)</th>
                                    <th class="rborder">DLI cumulatief (mol/m<sup>2</sup>)</th>
                                    <th>DLI belichting (mol/m<sup>2</sup>)</th>
                                    <th>DLI werkelijk<br />ontvangen (mol/m<sup>2</sup>)</th>
                                    <th>DLI cumulatief (mol/m<sup>2</sup>)</th>
                                </tr>

                                <!-- truukje om kolommen overeen te laten komen -->
                                <tr style="visibility: collapse">
                                    <td class="rborder">25/04/2019</td>
                                    <td>22.0</td>
                                    <td class="rborder">22.0</td>
                                    <td>22.0</td>
                                    <td>22.0</td>
                                    <td class="rborder">22.0</td>
                                    <td>22.0</td>
                                    <td>22.0</td>
                                    <td>22.0</td>
                                </tr>
                                <!-- tot hier -->

                                </thead>

                                <tbody>

                                <!-- truukje om kolommen overeen te laten komen -->
                                <tr style="visibility: collapse">
                                    <th class="rborder"></th>
                                    <th></th>
                                    <th class="rborder"></th>
                                    <th style="text-align: center;" :colspan="3" class="rborder">Klassieke belichting</th>
                                    <th style="text-align: center;" :colspan="3">Lichtintegratie</th>
                                </tr>
                                <tr style="visibility: collapse">
                                    <th class="rborder">Datum</th>
                                    <th>DLI gewenst (mol/m<sup>2</sup>)</th>
                                    <th class="rborder">DLI zon (mol/m<sup>2</sup>)</th>
                                    <th>DLI belichting (mol/m<sup>2</sup>)</th>
                                    <th>DLI werkelijk<br />ontvangen (mol/m<sup>2</sup>)</th>
                                    <th class="rborder">DLI cumulatief (mol/m<sup>2</sup>)</th>
                                    <th>DLI belichting (mol/m<sup>2</sup>)</th>
                                    <th>DLI werkelijk<br />ontvangen (mol/m<sup>2</sup>)</th>
                                    <th>DLI cumulatief (mol/m<sup>2</sup>)</th>
                                </tr>
                                <!-- tot hier -->

                                <tr v-for="(klassiek, indexi) in model.klassiekebelichting_n">
                                    <td class="rborder">{{datumDDMMYYYY(klassiek.datum)}}</td>
                                    <td>{{klassiek.gewensteDli}}</td>
                                    <td class="rborder">{{klassiek.dliZon}}</td>
                                    <td>{{komma2(klassiekmodel.klassiekebelichting_n[indexi].dliBelichting)}}</td>
                                    <td v-bind:class="genoegLicht(klassiek.gewensteDli, klassiekmodel.klassiekebelichting_n[indexi].dliTot)">{{komma1(klassiekmodel.klassiekebelichting_n[indexi].dliTot)}}</td>
                                    <td class="rborder">{{komma1(dliklassiekcumulatief[indexi])}}</td>
                                    <td>{{komma2(klassiek.dliBelichting)}}</td>
                                    <td v-bind:class="genoegLicht(klassiek.gewensteDli, klassiek.totDli)">{{komma1(klassiek.totDli)}}</td>
                                    <td>{{komma1(dlicumulatief[indexi])}}</td>
                                </tr>

                                </tbody>
                            </table>
                        </div><!--/.col-->
                    </div><!--/.row-->

                    <!-- Energie -->
                    <div v-show="schemabestaat && klassiekeurenbestaat && lichtintegratiebestaat && currentview == 'energie'" class="row animated fadeIn">
                        <div class="col-12">
                            <table class="table table-striped table-sm text-center table-fixed">
                                <thead>
                                <tr>
                                    <th class="rborder"></th>
                                    <th class="rborder" style="text-align: center;" :colspan="(aantalsystemen + 3)">Klassieke belichting</th>
                                    <th style="text-align: center;" :colspan="(aantalsystemen + 3)">Lichtintegratie</th>
                                </tr>
                                <tr>
                                    <th class="rborder"></th>
                                    <template>
                                        <th>DLI belichting</th>
                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)" class="rborder">Energie (kWh/m<sup>2</sup>)</th>
                                    </template>

                                    <template>
                                        <th style="text-align: center;">DLI belichting</th>
                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)">Energie (kWh/m<sup>2</sup>)</th>
                                    </template>
                                </tr>
                                <tr>
                                    <th class="rborder">Datum</th>
                                    <template>
                                        <th>(mol/m<sup>2</sup>)</th>
                                        <template v-for="i in aantalsystemen">
                                            <th style="text-align: center;">{{i}}</th>
                                        </template>
                                        <th>T</th>
                                        <th class="rborder">C</th>
                                    </template>

                                    <template>
                                        <th>(mol/m<sup>2</sup>)</th>
                                        <template v-for="i in aantalsystemen">
                                            <th style="text-align: center;">{{i}}</th>
                                        </template>
                                        <th>T</th>
                                        <th>C</th>
                                    </template>
                                </tr>

                                <!-- truukje om kolommen overeen te laten komen -->
                                <tr style="visibility: collapse">
                                    <td class="rborder">23/02/2020</td>
                                    <td>2.00</td>
                                    <template v-if="klassiekeurenbestaat">
                                        <template v-if="klassiekeurenbestaat">
                                            <template v-for="(klassiekperdag, indexk) in modelklassiekeuren.klassiekebelichting_n[0].klassiekperdag_n">
                                                <td style="text-align: center;">0.22</td>
                                            </template>
                                            <td>{{komma2(energieklassiektotaal[model.klassiekebelichting_n.length - 1])}}</td>
                                            <td class="rborder">{{komma2(energieklassiekcumulatief[model.klassiekebelichting_n.length - 1])}}</td>
                                        </template>
                                    </template>

                                    <template v-if="lichtintegratiebestaat">
                                        <td>22.00</td>
                                        <template v-for="(systeem, indexk) in modellichtintegratie.klassiekebelichting_n[0].systemen">
                                            <td style="text-align: center;">0.22</td>
                                        </template>
                                        <td>{{komma2(energieideaaltotaal[model.klassiekebelichting_n.length - 1])}}</td>
                                        <td>{{komma2(energieideaalcumulatief[model.klassiekebelichting_n.length - 1])}}</td>
                                    </template>
                                </tr>
                                <!-- tot hier -->

                                </thead>

                                <tbody>

                                <!-- truukje om kolommen overeen te laten komen -->
                                <tr style="visibility: collapse">
                                    <th class="rborder"></th>
                                    <th class="rborder" style="text-align: center;" :colspan="(aantalsystemen + 3)">Klassieke belichting</th>
                                    <th style="text-align: center;" :colspan="(aantalsystemen + 3)">Lichtintegratie</th>
                                </tr>
                                <tr style="visibility: collapse">
                                    <th class="rborder"></th>
                                    <template>
                                        <th>DLI belichting</th>
                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)" class="rborder">Energie (kWh/m<sup>2</sup>)</th>
                                    </template>

                                    <template>
                                        <th style="text-align: center;">DLI belichting</th>
                                        <th style="text-align: center;" :colspan="(aantalsystemen + 2)">Energie (kWh/m<sup>2</sup>)</th>
                                    </template>
                                </tr>
                                <tr style="visibility: collapse">
                                    <th class="rborder">Datum</th>
                                    <template>
                                        <th>(mol/m<sup>2</sup>)</th>
                                        <template v-for="i in aantalsystemen">
                                            <th style="text-align: center;">{{i}}</th>
                                        </template>
                                        <th>T</th>
                                        <th class="rborder">C</th>
                                    </template>

                                    <template>
                                        <th>(mol/m<sup>2</sup>)</th>
                                        <template v-for="i in aantalsystemen">
                                            <th style="text-align: center;">{{i}}</th>
                                        </template>
                                        <th>T</th>
                                        <th>C</th>
                                    </template>
                                </tr>
                                <!-- tot hier -->

                                <tr v-for="(klassiek, indexi) in model.klassiekebelichting_n">
                                    <td class="rborder">{{datumDDMMYYYY(klassiek.datum)}}</td>

                                    <template v-if="klassiekeurenbestaat">
                                        <td v-if="klassiekeurenbestaat">{{komma2(modelklassiekeuren.klassiekebelichting_n[indexi].dliBelichting)}}</td>
                                        <template v-if="klassiekeurenbestaat">
                                            <template v-for="(klassiekperdag, indexk) in modelklassiekeuren.klassiekebelichting_n[indexi].klassiekperdag_n">
                                                <td style="text-align: center;">{{komma2(energieklassiek[indexi].klassiekperdag[indexk].kwh)}}</td>
                                            </template>
                                            <td>{{komma2(energieklassiektotaal[indexi])}}</td>
                                            <td class="rborder">{{komma2(energieklassiekcumulatief[indexi])}}</td>
                                        </template>
                                    </template>

                                    <template v-if="lichtintegratiebestaat">
                                        <td v-if="lichtintegratiebestaat">{{komma2(modellichtintegratie.klassiekebelichting_n[indexi].dliBelichting)}}</td>
                                        <template v-for="(systeem, indexk) in modellichtintegratie.klassiekebelichting_n[indexi].systemen">
                                            <td style="text-align: center;">{{komma2(energieideaal[indexi].systeem[indexk].kwh)}}</td>
                                        </template>
                                        <td>{{komma2(energieideaaltotaal[indexi])}}</td>
                                        <td>{{komma2(energieideaalcumulatief[indexi])}}</td>
                                    </template>

                                </tr>

                                </tbody>
                            </table><span style="float:right;width:40px;">&nbsp;</span>

                            <!--
                            <br />

                             -->

                        </div><!--/.col-->
                    </div><!--/.row-->

                    <div v-show="schemabestaat && currentview == 'grafiek'" class="row animated fadeIn">
                        <div class="col-12">
                            <h5 class="card-title mb-0">Lichtintegratie vs. klassiek belichtingsschema</h5>
                            <br />
                            <div class="small text-muted">mol/m<sup>2</sup></div>
                            <chart ref="grafiek" :chart-data="datacollection" class="chart-wrapper" style="height:400px;margin-top:10px;margin-bottom:40px;" height="400" :miny="miny" :maxy="maxy" :changeyaxis="changeyaxis"></chart>
                        </div>
                    </div>

                    <div v-show="schemabestaat && currentview == 'grafiek'" class="row animated fadeIn">
                        <div class="col-12">
                            <h5 class="card-title mb-0">Lichtintegratie vs. klassiek belichtingsschema (cumulatief)</h5>
                            <br />
                            <div class="small text-muted">mol/m<sup>2</sup></div>
                            <chartm ref="grafiek" :chart-data="datacollection2" class="chart-wrapper" style="height:400px;margin-top:10px;margin-bottom:40px;" height="400" :miny="miny2" :maxy="maxy2" :changeyaxis="changeyaxis2"></chartm>
                        </div>
                    </div>

                    <div v-show="klassiekeurenbestaat && lichtintegratiebestaat && currentview == 'grafiek'" class="row animated fadeIn">
                        <div class="col-12">
                            <h5 class="card-title mb-0">Cumulatief elektriciteitsverbruik</h5>
                            <br />
                            <div class="small text-muted">kWh/m<sup>2</sup></div>
                            <chart :chart-data="datacollection3" class="chart-wrapper" style="height:400px;margin-top:10px;margin-bottom:40px;" height="400" :miny="miny3" :maxy="maxy3" :changeyaxis="changeyaxis3"></chart>
                        </div>
                    </div>

                    <form @submit.prevent="saveItem">

                    <div slot="footer">
                        <b-button type="button" @click="back" variant="secondary">Terug</b-button>
                    </div>

                    </form>

                </b-card>
            </div>
        </div>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker';
    import { nl } from 'vuejs-datepicker/dist/locale';

    import datefunctions from '../../helpers/datefunctions';
    import Chart from './ChartNotStacked';
    import ChartM from './ChartMixed';

    export default {
        name: 'Form',
        props: ['model', 'klassiekmodel', 'modellichtintegratie', 'invloedspercentages', 'modelklassiekeuren', 'isEditing'],
        data () {
            return {
                nl,
                firstrow: -1,
                currentview: 'data',
                datacollection: null,   // voor eerste grafiek
                datacollection2: null,  // voor tweede grafiek (cumulatief)
                datacollection3: null,  // voor tweede grafiek (electriciteitsverbruik)
                miny: 0,
                maxy: 25,
                changeyaxis: false, // telkens deze wijzigt, hertekent de eerste grafiek zich
                miny2: 0,
                maxy2: 25,
                changeyaxis2: false, // telkens deze wijzigt, hertekent de tweede grafiek zich
                miny3: 0,
                maxy3: 25,
                changeyaxis3: false, // telkens deze wijzigt, hertekent de tweede grafiek zich
                begindatum: '',
                einddatum: '',
                disabled: {
                    to: new Date(),
                    from: new Date(),
                },
                bordercolors: ['rgba(255, 128, 0, 1)', 'rgba(0, 204, 204, 1)', 'rgba(255,20,147, 1)', 'rgba(0, 0, 102,1)', 'rgba(193,46,12,1)', 'rgba(0,0,0,1)', 'rgba(50,205,50,1)', 'rgba(72,209,204,1)', 'rgba(139,0,139,1)', 'rgba(255,221,50,1)'],
                fillcolors: ['rgba(255, 128, 0, 0.2)', 'rgba(0, 204, 204, 0.2)', 'rgba(255,20,147, 0.2)', 'rgba(0, 0, 102,0.2)', 'rgba(193,46,12,0.2)', 'rgba(0,0,0,0.2)', 'rgba(50,205,50,0.2)', 'rgba(72,209,204,0.2)', 'rgba(139,0,139,0.2)', 'rgba(255,221,50,0.2)'],
            };
        },
        methods: {
            changeView (view) {
                this.currentview = view;
                if (view === 'grafiek') {
                    if (this.begindatum === '') {
                        this.begindatum = new Date(this.model.klassiekebelichting_n[0].datum);
                        this.einddatum = new Date(this.model.klassiekebelichting_n[this.model.klassiekebelichting_n.length - 1].datum);
                        this.disabled.to = this.begindatum;
                        this.disabled.from = this.einddatum;
                    }
                    this.fillGraphData();
                    this.fillGraph2Data();
                    this.fillGraph3Data();
                }
            },
            getMinValueDatasets (datasets) {
                // array met allemaal nullen die even groot is als het aantal waarden in de grafiek
                const somMinwaarden = [];
                datasets[0].data.forEach((waarde) => somMinwaarden.push(0)); // gewoon de eerste pakken

                // som maken van alle negatieve waarden voor alle datasets
                datasets.forEach((dataset) => {
                    for (let i = 0; i < dataset.data.length; i++) {
                        if (dataset.data[i] < 0) {
                            somMinwaarden[i] = somMinwaarden[i] + parseFloat(dataset.data[i]);
                        }
                    }
                });

                // kleinste pakken
                let minwaarde = Math.min(...somMinwaarden);
                return Math.floor((minwaarde + 0.00000001) / 5) * 5;
            },
            getMaxValueDatasets (datasets) {
                let maxwaarde = 0;
                datasets.forEach((dataset) => {
                    maxwaarde = Math.max(maxwaarde, Math.max(...dataset.data));
                });
                return (Math.floor((maxwaarde - 0.00000001) / 5) + 1) * 5;
            },
            fillGraphs () {
                this.fillGraphData();
                this.fillGraph2Data();
                this.fillGraph3Data();
            },
            fillGraphData () {
                this.datacollection = {
                    type: 'bar',
                    labels: this.getGraphLabels(),
                    datasets: this.getGraphBarsAndLines(),
                };
                this.miny = this.getMinValueDatasets(this.datacollection.datasets);
                this.maxy = this.getMaxValueDatasets(this.datacollection.datasets);
                this.changeyaxis = !this.changeyaxis;
            },
            fillGraph2Data () {
                this.datacollection2 = {
                    type: 'bar',
                    labels: this.getGraphLabels(),
                    datasets: this.getGraphLines(),
                };
                this.miny2 = 0;
                this.maxy2 = this.getMaxValueDatasets(this.datacollection2.datasets);
                this.changeyaxis2 = !this.changeyaxis2;
            },
            fillGraph3Data () {
                this.datacollection3 = {
                    type: 'bar',
                    labels: this.getGraphLabels(),
                    datasets: this.getGraphBarsAndLinesEnergie(),
                };
                this.miny3 = 0;
                this.maxy3 = this.getMaxValueDatasets(this.datacollection3.datasets);
                this.changeyaxis3 = !this.changeyaxis3;
            },
            getGraphLabels () {
                const labels = [];
                this.model.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        labels.push(this.datumDDMMYYYY(klassiek.datum));
                    }
                });
                return labels;
            },
            getGraphBarsAndLinesEnergie () {
                const datasets = [];
                this.getGraphEnergieKlassiek(datasets);
                this.getGraphEnergieIdeaal(datasets);
                return datasets;
            },
            getGraphEnergieIdeaal (datasets) {
                const data = [];
                let indexi = 0;
                this.modellichtintegratie.klassiekebelichting_n.forEach((werkelijk) => {
                    if ((werkelijk.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (werkelijk.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(this.energieideaalcumulatief[indexi]));
                    }
                    indexi++;
                });
                const dataset = {
                    backgroundColor: 'rgba(204,0,0, 0)',
                    borderColor: 'rgba(204,0,0, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: ' Lichtintegratie',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphEnergieKlassiek (datasets) {
                const data = [];
                let indexi = 0;
                this.modelklassiekeuren.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(this.energieklassiekcumulatief[indexi]));
                    }
                    indexi++;
                });
                const dataset = {
                    backgroundColor: 'rgba(0, 204, 0, 0)',
                    borderColor: 'rgba(0, 204, 0, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: ' Klassiek belichting',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphBarsAndLines () {
                const datasets = [];
                this.getGraphDLIKlassiekeBelichting(datasets);
                this.getGraphDLILichtintegratie(datasets);

                this.getGraphDliZon(datasets);
                this.getGraphDliGewenst(datasets);
                this.getGraphDliWerkelijkKlassiekeBelichting(datasets);
                this.getGraphDliWerkelijkLichtintegratie(datasets);
                return datasets;
            },
            getGraphLines () {
                const datasets = [];
                this.getGraphDliCumulatiefKlassiekeBelichting(datasets);
                this.getGraphDliCumulatiefLichtintegratie(datasets);
                return datasets;
            },
            getGraphDLIKlassiekeBelichting (datasets) {
                const dataset = {
                    backgroundColor: this.fillcolors[1],
                    borderColor: this.bordercolors[1],
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 1,
                    label: 'DLI Belichting (Klassieke belichting)',
                    data: this.getDataKlassiekeBelichting(),
                    yAxisID: 'bar',
                };
                datasets.push(dataset);
            },
            getGraphDLILichtintegratie (datasets) {
                const dataset = {
                    backgroundColor: this.fillcolors[2],
                    borderColor: this.bordercolors[2],
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 1,
                    label: 'DLI Belichting (Lichtintegratie)',
                    data: this.getDataLichtintegratie(),
                    yAxisID: 'bar',
                };
                datasets.push(dataset);
            },
            getDataKlassiekeBelichting () {
                const data = [];
                this.klassiekmodel.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(klassiek.dliBelichting));
                    }
                });
                return data;
            },
            getDataLichtintegratie () {
                const data = [];
                this.model.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(klassiek.dliBelichting));
                    }
                });
                return data;
            },
            getGraphDliZon (datasets) {
                const data = [];
                this.model.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(klassiek.dliZon);
                    }
                });
                const dataset = {
                    backgroundColor: 'rgba(0,153,153, 0)',
                    borderColor: 'rgba(0,153,153, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: ' DLI zon',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphDliGewenst (datasets) {
                const data = [];
                this.model.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(klassiek.gewensteDli);
                    }
                });
                const dataset = {
                    backgroundColor: 'rgba(23,23,23, 0)',
                    borderColor: 'rgba(23,23,23, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: ' DLI gewenst',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphDliWerkelijkKlassiekeBelichting (datasets) {
                const data = [];
                this.klassiekmodel.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(klassiek.dliTot));
                    }
                });
                const dataset = {
                    backgroundColor: 'rgba(0, 204, 0, 0)',
                    borderColor: 'rgba(0, 204, 0, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: 'DLI Werkelijk ontvangen (Klassieke belichting)',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphDliWerkelijkLichtintegratie (datasets) {
                const data = [];
                this.model.klassiekebelichting_n.forEach((klassiek) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(klassiek.totDli));
                    }
                });
                const dataset = {
                    backgroundColor: 'rgba(204,0,0, 0)',
                    borderColor: 'rgba(204,0,0, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: 'DLI Werkelijk ontvangen (Lichtintegratie)',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphDliCumulatiefKlassiekeBelichting (datasets) {
                const data = [];
                this.klassiekmodel.klassiekebelichting_n.forEach((klassiek, index) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(this.dliklassiekcumulatief[index]));
                    }
                });
                const dataset = {
                    backgroundColor: 'rgba(0, 204, 0, 0)',
                    borderColor: 'rgba(0, 204, 0, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: 'DLI Cumulatief (Klassieke belichting)',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            getGraphDliCumulatiefLichtintegratie (datasets) {
                const data = [];
                this.klassiekmodel.klassiekebelichting_n.forEach((klassiek, index) => {
                    if ((klassiek.datum >= datefunctions.datetoYYYYMMDDZero(this.begindatum)) && (klassiek.datum <= datefunctions.datetoYYYYMMDDZero(this.einddatum))) {
                        data.push(this.komma2(this.dlicumulatief[index]));
                    }
                });
                const dataset = {
                    backgroundColor: 'rgba(204,0,0, 0)',
                    borderColor: 'rgba(204,0,0, 1)',
                    pointHoverBackgroundColor: '#fff',
                    borderWidth: 2,
                    type: 'line',
                    label: 'DLI Cumulatief (Lichtintegratie)',
                    data,
                    yAxisID: 'line',
                };
                datasets.push(dataset);
            },
            wis (perdag) {
                perdag.tijd = '00:00';
            },
            klikt (index) {
                if (this.model.klassiekebelichting_n[index].selected === 0) {
                    if (this.firstrow === -1) {
                        this.model.klassiekebelichting_n[index].selected = 1;
                        this.firstrow = index;
                    } else if (this.firstrow < index) {
                        for (let i = this.firstrow + 1; i <= index; i += 1) {
                            for (let j = 0; j < this.model.klassiekebelichting_n[this.firstrow].klassiekperdag_n.length; j += 1) {
                                this.model.klassiekebelichting_n[i].klassiekperdag_n[j].tijd =
                                    this.model.klassiekebelichting_n[this.firstrow].klassiekperdag_n[j].tijd;
                            }
                        }
                        this.model.klassiekebelichting_n[this.firstrow].selected = 0;
                        this.firstrow = -1;
                    }
                } else {
                    this.model.klassiekebelichting_n[index].selected = 0;
                    this.firstrow = -1;
                }
            },
            selectValue (klassiek) {
                if (klassiek.selected === 0) {
                    return 'fa fa-navicon';
                }
                if (klassiek.selected === 1) {
                    return 'fa fa-sort-amount-asc';
                }
                return '';
            },
            genoegLicht (nodig, hebje) {
                if (hebje >= nodig) {
                    return 'green';
                }
                if (hebje >= (nodig * 0.75)) {
                    return 'orange';
                }
                return 'red';
            },
            createschema () {
                this.$emit('create-schema', this.model);
            },
            saveItem () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        if (!this.isError) {
                            this.$emit('save-item', this.model);
                        }
                    }
                });
            },
            back () {
                this.$router.go(-1);
            },
            datumDDMMYYYY (datum) {
                return datefunctions.datetoDDMMYYYY(datum);
            },
            timeHHMM (time) {
                return datefunctions.timetoHHMM(time);
            },
            berekenVermogen (schakelniveau, belichting) {
                /* eslint max-len: ["error", { "code": 300 }] */
                return (belichting.fotonflux * schakelniveau.percentage) / 100;
            },
            komma4 (waarde) {
                if (isNaN(waarde)) {
                    return '#.####';
                }
                return waarde.toFixed(4);
            },
            komma2 (waarde) {
                if (isNaN(waarde)) {
                    return '#.##';
                }
                return waarde.toFixed(2);
            },
            komma1 (waarde) {
                if (isNaN(waarde)) {
                    return '#.#';
                }
                return waarde.toFixed(1);
            },
            komma0 (waarde) {
                if (isNaN(waarde)) {
                    return '#';
                }
                return waarde.toFixed(0);
            },
        },
        computed: {
            aantalsystemen () {
                let aantal = 0;
                this.model.afdeling.belichting_n.forEach((belichting) => {
                    aantal += belichting.schakelniveau_n.length;
                });
                return aantal;
            },
            klassiekeurenbestaat () {
                // return ('klassiekebelichting_n' in this.modelklassiekeuren);
                return ((Object.keys(this.modelklassiekeuren).length !== 0) && (this.modelklassiekeuren.klassiekebelichting_n.length !== 0));
            },
            lichtintegratiebestaat () {
                // return ('klassiekebelichting_n' in this.modellichtintegratie);
                return ((Object.keys(this.modellichtintegratie).length !== 0) && (this.modellichtintegratie.klassiekebelichting_n.length !== 0));
            },
            schemabestaat () {
                return (this.model.klassiekebelichting_n.length !== 0);
            },
            aantalverleden () {
                return this.invloedspercentages.verleden.aantaldagen;
            },
            aantaltoekomst () {
                return this.invloedspercentages.toekomst.aantaldagen;
            },
            dlicumulatief () {
                const resultaat = [];
                let vorigtotaal = this.model.cumulatief;
                this.model.klassiekebelichting_n.forEach((klassiek) => {
                    resultaat.push(vorigtotaal + klassiek.totDli);
                    vorigtotaal += klassiek.totDli;
                });
                return resultaat;
            },
            dliklassiekcumulatief () {
                const resultaat = [];
                let vorigtotaal = this.model.cumulatief;
                this.klassiekmodel.klassiekebelichting_n.forEach((klassiek) => {
                    resultaat.push(vorigtotaal + klassiek.dliTot);
                    vorigtotaal += klassiek.dliTot;
                });
                return resultaat;
            },
            installatie () {
                const resultaat = [];
                this.model.afdeling.belichting_n.forEach((belichting) => {
                    belichting.schakelniveau_n.forEach((schakelniveau) => {
                        resultaat.push(this.berekenVermogen(schakelniveau, belichting));
                    });
                });
                return resultaat;
            },
            efficientie () {
                const resultaat = [];
                this.model.afdeling.belichting_n.forEach((belichting) => {
                    belichting.schakelniveau_n.forEach((schakelniveau) => {
                        resultaat.push(belichting.efficientie);
                    });
                });
                return resultaat;
            },
            // 2 keer hetzelfde (energie voor ideaal (=lichtintegratie), klassiek), is eigenlijk niet goed, maar ja
            energieideaal () {
                const resultaat = [];
                this.modellichtintegratie.klassiekebelichting_n.forEach((klassiekebelichting) => {
                    const systeemarray = [];
                    klassiekebelichting.systemen.forEach((systeem, i) => {
                        systeemarray.push({ kwh: (((datefunctions.getSeconden(systeem.belichtingsuren)
                            * this.installatie[i]) / systeem.efficientie) / 3600000)});
                    });
                    resultaat.push({ datum: klassiekebelichting.datum, systeem: systeemarray });
                });
                return resultaat;
            },
            energieideaaltotaal () {
                const resultaat = [];
                let i = 0;
                this.energieideaal.forEach((energieideaal) => {
                    let totaal = 0;
                    energieideaal.systeem.forEach((systeem) => {
                        if (! isNaN(systeem.kwh)) {
                            totaal += systeem.kwh;
                        }
                    });
                    resultaat.push(totaal);
                    i += 1;
                });
                return resultaat;
            },
            energieideaalcumulatief () {
                const resultaat = [];
                let vorigtotaal = 0;
                this.energieideaaltotaal.forEach((energieideaaltotaal) => {
                    resultaat.push(vorigtotaal + energieideaaltotaal);
                    vorigtotaal += energieideaaltotaal;
                });
                return resultaat;
            },
            energieklassiek () {
                const resultaat = [];
                this.modelklassiekeuren.klassiekebelichting_n.forEach((klassiekebelichting) => {
                    const klassiekperdagarray = [];
                    klassiekebelichting.klassiekperdag_n.forEach((klassiekperdag, i) => {
                        klassiekperdagarray.push({ kwh: (((datefunctions.getSeconden(klassiekperdag.tijd)
                            * this.installatie[i]) / this.efficientie[i]) / 3600000)});
                    });
                    resultaat.push({ datum: klassiekebelichting.datum, klassiekperdag: klassiekperdagarray });
                });
                return resultaat;
            },
            energieklassiektotaal () {
                const resultaat = [];
                let i = 0;
                this.energieklassiek.forEach((energieklassiek) => {
                    let totaal = 0;
                    energieklassiek.klassiekperdag.forEach((klassiekperdag) => {
                        if (! isNaN(klassiekperdag.kwh)) {
                            totaal += klassiekperdag.kwh;
                        }
                    });
                    resultaat.push(totaal);
                    i += 1;
                });
                return resultaat;
            },
            energieklassiekcumulatief () {
                const resultaat = [];
                let vorigtotaal = 0;
                this.energieklassiektotaal.forEach((energieklassiektotaal) => {
                    resultaat.push(vorigtotaal + energieklassiektotaal);
                    vorigtotaal += energieklassiektotaal;
                });
                return resultaat;
            },
        },
        components: {
            datepicker: Datepicker,
            chart: Chart,
            chartm: ChartM,
        },
    };
</script>

<style>

    .rborder
    {
        border-right: 1px solid #DDD;
    }

    .red {
        color: red;
    }
    .green {
        color: lawngreen;
    }
    .orange {
        color: orange;
    }

    input, select {
        padding: .55em .5em;
        font-size: 100%;
        border: 1px solid #ccc;
        width: 100%
    }

    .unstyleduur {
        padding: 0.1em;
        width: 3em;
    }

    .centered {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .unstyleduur::-webkit-outer-spin-button, /* Removes arrows */
    .unstyleduur::-webkit-inner-spin-button, /* Removes arrows */
    .unstyleduur::-webkit-clear-button { /* Removes blue cross */
        -webkit-appearance: none;
        margin: 0;
    }
    /*.unstyleduur::-webkit-calendar-picker-indicator {
      display: none;
      -webkit-appearance: none;
    }*/

    .table-nonfluid {
        width: auto !important;
    }

    .table-fixed tbody {
        height: calc( 100vh - 220px );
        overflow-y: auto;
    }

    .table-fixed thead, .table-fixed tbody{
        display: block;
    }

</style>



// WEBPACK FOOTER //
// src/pages/licht/FormSamenvatting.vue